var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23 17.8h-2.7v11.9h7.6v-2.5H23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.8 12c-3.1 0-6 1.2-8.2 3.4-2.3 2.2-3.5 5.2-3.5 8.3s1 5.5 2.7 7.5l-2.9 2.9 1.4 1.4 2.9-2.9c2 1.7 4.7 2.8 7.5 2.8 3.1 0 6.1-1.2 8.3-3.4s3.4-5.2 3.4-8.3V12H23.7Zm9.7 11.7c0 2.6-1 5-2.8 6.9-1.8 1.8-4.3 2.8-6.9 2.8-5.3 0-9.7-4.4-9.7-9.7s1-5.1 2.9-6.9c1.8-1.8 4.2-2.8 6.8-2.8h9.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLite);
export default __webpack_public_path__ + "static/media/IcoLite.7b9a7a31ce2917911e0acef3e4899747.svg";
export { ForwardRef as ReactComponent };